import redpipeService from '../services/redpipe.service'

const handlers = {
  redpipe: {
    session: {
      set: 'redpipe_session_set'
    },
    frameParameters: {
      set: 'redpipe_frameParameters_set'
    },
    gameUrl: {
      set: 'redpipe_gameUrl_set'
    }
  }
}

const initVuexState = function(state) {
  state.redpipe = {
    session: null,
    frameParameters: [],
    gameUrl: null
  };
}

const initGetters = function(getters) {
  getters.redpipe = (state => state.redpipe);
}

const initActions = function(actions) {
  actions[handlers.redpipe.session.set] = ({ commit }, session) => commit(handlers.redpipe.session.set, session);
  actions[handlers.redpipe.frameParameters.set] = ({ commit }, frameParameters) => commit(handlers.redpipe.frameParameters.set, frameParameters);
  actions[handlers.redpipe.gameUrl.set] = ({ commit }, gameUrl) => commit(handlers.redpipe.gameUrl.set, gameUrl);
}

const initMutations = function(mutations) {
  mutations[handlers.redpipe.session.set] = (state, session) => state.redpipe.session = session;
  mutations[handlers.redpipe.frameParameters.set] = (state, frameParameters) => state.redpipe.frameParameters = frameParameters;
  mutations[handlers.redpipe.gameUrl.set] = (state, gameUrl) => state.redpipe.gameUrl = gameUrl;
}

const initAppState = function(appState, store) {
  appState.redpipe = {
    session: {
      get: () => store.getters.redpipe.session,
      open: async (gameId, language, backUrl) => {
        let session = await redpipeService.openSession(gameId, language, backUrl);
        store.dispatch(handlers.redpipe.session.set, session);
      },
      openDemo: async (gameId, language, backUrl) => {
        let session = await redpipeService.openDemoSession(gameId, language, backUrl);
        store.dispatch(handlers.redpipe.session.set, session);
      },
      close: async () => {
        store.dispatch(handlers.redpipe.session.set, null);
        store.dispatch(handlers.redpipe.gameUrl.set, null);
        if (store.getters.redpipe.session) {
          await redpipeService.closeSession();
        }
      }
    },
    frameParameters: {
      get: () => store.getters.redpipe.frameParameters,
      set: (frameParameters) => {
        store.dispatch(handlers.redpipe.frameParameters.set, frameParameters);
      }
    },
    gameUrl: {
      get: () => store.getters.redpipe.gameUrl,
      set: (gameUrl) => {
        store.dispatch(handlers.redpipe.gameUrl.set, gameUrl);
      }
    }
  }
}

export default {
  initVuex(vuexState, getters, actions, mutations) {
    initVuexState(vuexState);
    initGetters(getters);
    initActions(actions);
    initMutations(mutations);
  },
  initAppState(appState, store) {
    initAppState(appState, store);
  }
}



// WEBPACK FOOTER //
// ./_common/data/redpipe.js